import { getApolloClient } from '#providers/apollo/initializeClient';
import {
  GetSearchSuggestionsDocument,
  GetSearchResultsCountDocument,
} from '#types/generated/apollo-client';
import { SearchParams } from '#types/generated/graphql-types';

export const api = {
  async search(query: string) {
    const client = getApolloClient();
    const { data } = await client.query({
      query: GetSearchSuggestionsDocument,
      variables: { params: { needle: query, itemsPerPage: 15, page: 1 } },
      fetchPolicy: 'network-only',
    });
    return data?.search?.items?.map((item) => ({ ...item })) || [];
  },

  async getSearchCount(query: string, apiFilters: SearchParams) {
    const client = getApolloClient();
    const { data } = await client.query({
      query: GetSearchResultsCountDocument,
      variables: {
        params: {
          needle: query,
          itemsPerPage: 1,
          page: 1,
          ...apiFilters,
        },
      },
      fetchPolicy: 'network-only',
    });
    return data?.searchWithFacets?.totalItems || 0;
  },
};
